export default {
    SIGN_IN: "Войти",
    LOGIN: "Логин",
    LOGIN_PLACEHOLDER: "Введите логин",
    EMAIL: "Электронный адрес",
    EMAIL_PLACEHOLDER: "Введите электронный адрес ",
    PASSWORD: "Пароль",
    PASSWORD_PLACEHOLDER: "Введите пароль",
    UNKNOWN_ERROR: "Произошла неизвестная ошибка. Пожалуйста, попробуйте еще раз.",
    NETWORK_ERROR: "Ошибка сети. Пожалуйста, проверьте ваше соединение.",
    LOADING: "Загрузка..."
};
